import $ from 'jquery';
import skipLinks from './utils/skipLinks';
import iframer from './utils/iframer';
// import closeNotification from './utils/closeNotification';
import mNav from './utils/mNav';
import setupDrawers from './utils/setupDrawers';
import equalHeight from './utils/equalHeight';
import googleMaps from './utils/googleMaps';
import twitterFeed from './utils/twitterFeed';
import setupTabs from './utils/setupTabs';
import setupTagsReveal from './utils/setupTagsReveal';
import listShowHide from './utils/listShowHide';
import setupSharing from './utils/social';
import multiSelect from './utils/multiSelect';
import multiNav from './utils/multiNav';

function globals () {

    // iframe video in body content
    iframer();

    // Close top notification bar
    // closeNotification();

    // Small Screen Navigation
    mNav(
        '#navigation-primary__toggle',
        'navigation-primary__toggle--open',
        '#navigation-primary__items',
        'navigation-primary__items--open'
    );

    // inpage showHide
    mNav(
        '#navigation-inpage-trigger',
        'navigation-inpage__trigger--open',
        '#navigation-inpage__items',
        'navigation-inpage__items--open'
    );

    // Multi Navigation
    multiNav(
        '#navigation-primary',
    );

    // Research team show/hide
    // Check here: http://localhost:3000/03-1-0-research-projects/
    setupDrawers();

    // Equal height
    // Check here: http://localhost:3000/02-2-partners/
    equalHeight('#panels-parent', '.panel');

    // Tabs
    // Check here: http://localhost:3000/03-0-research-implementation/
    setupTabs();

    // Show tags in sidebar
    // Check here: http://localhost:3000/03-1-1-research-project-single/
    setupTagsReveal();

    // google maps
    googleMaps();

    // twitters
    twitterFeed();

    // multiSelect
    multiSelect();
    $('select.multi-select').multiselect();
}

$(function run () {
    console.log('ᕕ( ᐛ )ᕗ Running...');
    globals();
});